
    // this file was auto generated by python script
    import Search from './Search';
    export default Search;
    